module.exports = {
    voltage: "Voltage [U]",
    current: "Current [I]",
    voltage_angle: "Voltage Angle [φᵤ]",
    current_angle: "Current Angle [φᵢ]",
    power_factor: "Power Factor [cos φ]",
    active_power: "Active Power [P]",
    reactive_power: "Reactive Power [Q]",
    apparent_power: "Apparent Power [S]",
    voltage_distortion: "Voltage Distortion [DFᵤ]",
    current_distortion: "Current Distortion [DFᵢ]",
    phase_to_phase_voltage: "Phase to Phase Voltage [Uₚₚ]",
    phase_to_phase_voltage_angle: "Uₚₚ Voltage Angle [φUₚₚ]",
    active_energy: "Active Energy [Eₚ]",
    reactive_energy: "Reactive Energy [Eq]",
    apparent_energy: "Apparent Energy [Eₛ]"
}